var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import "vue";
function createInjectionKey() {
  return Symbol();
}
class Timer {
  constructor(callback, delay, isPaused = false) {
    __publicField(this, "_timerId");
    __publicField(this, "_start");
    __publicField(this, "_remaining");
    __publicField(this, "_isPaused");
    __publicField(this, "_callback");
    this._start = /* @__PURE__ */ new Date();
    this._callback = callback;
    this._remaining = delay;
    this._isPaused = isPaused;
    this.resume();
    if (isPaused) {
      this.pause();
    }
  }
  get isPaused() {
    return this._isPaused;
  }
  pause() {
    this._isPaused = true;
    window.clearTimeout(this._timerId);
    this._remaining -= (/* @__PURE__ */ new Date()).getTime() - this._start.getTime();
  }
  resume() {
    this._isPaused = false;
    this._start = /* @__PURE__ */ new Date();
    window.clearTimeout(this._timerId);
    this._timerId = window.setTimeout(() => {
      window.clearTimeout(this._timerId);
      this._callback();
    }, this._remaining);
  }
}
function throwWarn(location, message) {
  console.warn(`[wui/${location}]: ${message}`);
}
function throwError(location, message) {
  throw new Error(`[wui/${location}]: ${message}`);
}
export {
  Timer,
  createInjectionKey,
  throwError,
  throwWarn
};
